
import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class HeaderService{
    isAgent:boolean;
    agentCredit:number;
    numElementsCart:number;
    locale:string;

    addToCart(){
        this.numElementsCart += 1;
    }

    removeFromCart(){
        this.numElementsCart -= 1;
    }

    setIsAgent(isAgent:boolean){
        this.isAgent = isAgent;
    }

    setAgentCredit(credit:number){
        this.agentCredit = credit;
    }
}